import {
    getOrderTotal,
    getOrderCredit,
} from '@perpay-web/fintech/selectors/entities/orders';
import { getCheckoutOrderUUID } from '@perpay-web/fintech/selectors/ui/checkout';
import { centsToDollar } from '@perpay-web/utils/numberUtils';

// Return the order amount of the current checkout formatted like 1.23
export function getOrderAmountWithoutCredit(state) {
    const orderUUID = getCheckoutOrderUUID(state);
    const orderTotal = getOrderTotal(state, orderUUID);
    const orderCredit = getOrderCredit(state, orderUUID);
    const amountWithoutCredits = orderTotal - orderCredit;
    return centsToDollar(amountWithoutCredits);
}

export const getCheckoutStepsRemaining = (
    hasBillingAddressValue,
    ssnIsVerified,
    cachedStepsRemaining,
) => {
    const stepsRemaining =
        cachedStepsRemaining !== null && cachedStepsRemaining !== undefined
            ? Number(cachedStepsRemaining)
            : null;

    if (stepsRemaining && Number.isFinite(stepsRemaining)) {
        // make sure the cached steps remaining is between 1 and 3
        return Math.max(1, Math.min(stepsRemaining, 3));
    }

    if (hasBillingAddressValue && ssnIsVerified) {
        return 1;
    }

    if (hasBillingAddressValue || ssnIsVerified) {
        return 2;
    }

    return 3;
};
